import React from 'react';
import Datas from '../../data/about-us/mondiya/about-us.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "../styles/mondiya/aboutUs.js";
import {useTranslation} from "react-i18next";

const AboutUs = () => {
    const { t } = useTranslation();
    return (
        <Styles>
            {/* About Us */}
            <section className="about-us">
                <Container>
                    <Row>
                        <Col md="6">
                            <div className="about-image">
                                <img src={process.env.PUBLIC_URL + `/assets/images/${Datas.mainImage}`} className="main-img" alt="" />
                                <img src={process.env.PUBLIC_URL + "/assets/images/pattern.png"} className="pattern-img" alt="" />
                            </div>
                        </Col>
                        <Col md="6">
                            <div className="about-content">
                                {/*<h4 className="about-title">{Datas.title}</h4>*/}
                                <p className="about-para">{t('aboutUsPage.desc1')}<span>{t('aboutUsPage.desc2')}</span><span>{t('aboutUsPage.desc3')}</span><span>{t('aboutUsPage.desc4')}</span><span>{t('aboutUsPage.desc5')}</span></p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default AboutUs